import React from 'react';
import { BookOpen } from 'lucide-react';
const books = [{
  number: 1,
  title: 'FAZA ZERO',
  subtitle: 'Wszystkie poziomy — Diagnoza i Organizacja',
  promise: 'Stwórz solidne podstawy dla każdej grupy. Gotowe plany diagnozowania grup od pierwszego dnia.',
  features: ['Główny plan 40 tygodni', 'Ćwiczenia diagnostyczne poziomów A/B/C', 'Protokół pierwszych 4 tygodni', 'Metoda R.E.P. z szablonami', 'Karty oceny uczniów', 'Listy obecności', 'Komunikacja z rodzicami']
}, {
  number: 2,
  title: 'MODUŁ INICJACJI',
  subtitle: 'U12 — Gra jako Fundament',
  promise: 'Gotowe plany lekcji rozwijające podstawy poprzez grę i zabawę — podejście Gra Pierwsze.',
  features: ['16 szczegółowych lekcji z grami', 'Bloki 4-tygodniowe z progresją', 'Mini-turnieje Gorący Piątek', 'System oceny 4P dla U12', 'Karta samooceny ucznia', 'Książka rekordów grupy', 'Certyfikat ukończenia modułu']
}, {
  number: 3,
  title: 'MODUŁ ROZWOJU',
  subtitle: 'U14 — Rola i Specjalizacja',
  promise: 'Gotowe plany lekcji rozwijające świadomość taktyczną — wprowadzenie ról i specjalizacji.',
  features: ['Specjalizacja ról: Rozgrywająca, Libero, Atakujący, Bloker', 'Diagnoza FAST-TRACK', 'Karty ról dla każdego gracza', 'System video-feedback', 'Mini-liga wewnętrzna', 'Różnicowanie 2.0', 'Karty oceny taktycznej']
}, {
  number: 4,
  title: 'MODUŁ KONSOLIDACJI',
  subtitle: 'U16 — System i Atak',
  promise: 'Ucz taktyki siatkówki profesjonalnie z jasnymi schematami i planami lekcji.',
  features: ['System rotacji 5-1', 'Taktyka ataku i bloku', 'Pressing i kontratak', 'Schematy stałych fragmentów gry', 'Plany meczowe', 'Karty oceny zespołowej']
}, {
  number: 5,
  title: 'MODUŁ RYWALIZACJI',
  subtitle: 'U18 — Zawodnik Kompletny',
  promise: 'Gotowe plany lekcji przygotowujące do rywalizacji na najwyższym poziomie.',
  features: ['Mentalność zawodnicza pod presją', 'Zagrywka skoczna — progresja', 'Analiza meczu i wideo', 'Przygotowanie psychologiczne', 'Schematy taktyczne zaawansowane', 'Karty oceny zawodnika kompletnego']
}, {
  number: 6,
  title: 'KALENDARZ 365',
  subtitle: 'Wszystkie poziomy — Master Plan',
  promise: 'Roczny system planowania dla nauczyciela i trenera. Obejmuje wszystkie poziomy, każdy miesiąc, każdy tydzień.',
  features: ['Szablony komunikacji z rodzicami', 'Indywidualne karty oceny', 'Listy obecności', 'Raporty miesięczne', 'Psychologia pracy z młodymi zawodnikami', 'Dokumenty klubowe i szkolne']
}];
export function SixBooks() {
  return <section className="w-full bg-cream-alt py-12 md:py-20 px-4 md:px-6" data-id="element-246">
      <div className="max-w-6xl mx-auto" data-id="element-247">
        <div className="text-center mb-8 md:mb-12" data-id="element-248">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-display font-bold text-white mb-3 md:mb-4" data-id="element-249">
            Kompletny system 6 tomów
          </h2>
          <p className="text-base md:text-lg text-[#9BA3B5] max-w-2xl mx-auto" data-id="element-250">
            Narzędzia cyfrowe w formacie PDF — gotowe do druku lub przeglądania
            na tablecie od dziś
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8" data-id="element-251">
          {books.map((book, index) => <div key={index} className="bg-[#1A3257] rounded-2xl overflow-hidden shadow-lg flex flex-col h-full border-l-4 border-gold-accent border-y border-r border-[#1E3A5F]" data-id="element-252">
              <div className="bg-[#0A1628] p-5 md:p-6 relative" data-id="element-253">
                <div className="absolute top-4 right-4 w-10 h-10 md:w-12 md:h-12 bg-gold-accent/20 rounded-full flex items-center justify-center border border-gold-accent/30" data-id="element-254">
                  <span className="text-xl md:text-2xl font-bold text-gold-accent" data-id="element-255">
                    {book.number}
                  </span>
                </div>
                <BookOpen className="w-8 h-8 md:w-10 md:h-10 text-gold-accent mb-3 md:mb-4" data-id="element-256" />
                <h3 className="text-lg md:text-xl font-display font-bold text-white" data-id="element-257">
                  TOM {book.number} — {book.title}
                </h3>
                <p className="text-gold-accent font-medium mt-1 text-sm" data-id="element-258">
                  {book.subtitle}
                </p>
              </div>
              <div className="p-5 md:p-6 flex-grow flex flex-col" data-id="element-259">
                <p className="text-sm md:text-base text-[#E8EAF0] leading-relaxed mb-4" data-id="element-260">
                  {book.promise}
                </p>
                <div className="mt-auto" data-id="element-261">
                  <p className="font-bold text-white text-sm mb-2" data-id="element-262">Zawiera:</p>
                  <ul className="text-sm text-[#9BA3B5] space-y-1" data-id="element-263">
                    {book.features.map((feature, i) => <li key={i} className="flex items-start gap-2" data-id="element-264">
                        <span className="text-gold-accent mt-0.5" data-id="element-265">•</span>
                        <span data-id="element-266">{feature}</span>
                      </li>)}
                  </ul>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}